export default __webpack_public_path__ + "static/media/Bjorn_NE.64ef8ebb.png";